import { Grid2 as Grid, styled } from "@mui/material";

export const ConditionContentItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

export const UnitContentItem = styled(Grid)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const RateContentItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const ComponentContentItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  [theme.breakpoints.down("lg")]: {
    width: "200px",
    minWidth: "200px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100px",
    minWidth: "100px",
  },
}));
